// Serviço para consumir, em tempo de execução, as chaves de API públicas
// (não-sensíveis) configuradas na tela "Configuração" do Gerenciador de
// Produtos (Google OAuth Client ID, chaves publicáveis de pagamento,
// status do Melhor Envio e dados bancários para transferência/boleto).
//
// O e-commerce NUNCA deve guardar segredos (secret keys / access tokens)
// no front-end - esses continuam apenas no Gerenciador de Produtos e são
// usados pelo backend/servidor quando necessário.

import { gerenciadorUrl } from "@/config/gerenciadorConfig";

let cachedConfigPromise = null;

/**
 * Busca (com cache em memória durante a sessão da página) as configurações
 * públicas do Gerenciador de Produtos.
 *
 * Em produção, a chamada é feita diretamente (cross-domain) para o
 * config_api.php do Gerenciador, cuja URL é resolvida de forma
 * centralizada em @/config/gerenciadorConfig.js - o mesmo padrão
 * comprovado já usado por getBanners()/getDestaquesSite() e pelas
 * chamadas de categorias/subcategorias (dados_api.php) em api.js e
 * CategoriasSite.vue. Esse método é mais confiável porque não depende de
 * "adivinhar" a estrutura de pastas do cPanel (../../.. a partir de
 * public_html/api) para localizar o arquivo pelo sistema de arquivos do
 * servidor - o endpoint já libera CORS (Access-Control-Allow-Origin: *)
 * para scope=public.
 *
 * Em desenvolvimento local, mantém o proxy same-origin /api/config_api.php
 * como fallback.
 */
export function getPublicApiConfig() {
  if (cachedConfigPromise) {
    return cachedConfigPromise;
  }

  let url = "/api/config_api.php";
  if (
    process.env.VUE_APP_ENV !== "dev" &&
    !window.location.hostname.includes("localhost")
  ) {
    url = `${gerenciadorUrl()}/api/config_api.php?scope=public`;
  }

  cachedConfigPromise = fetch(url)
    .then((res) => res.json())
    .then((json) => {
      if (json && json.status === "ok") {
        return json.data || {};
      }
      return {};
    })
    .catch(() => {
      // Em caso de falha (ex.: endpoint ainda não publicado neste ambiente),
      // retorna um objeto vazio para que os componentes usem seus valores
      // padrão/fallback sem quebrar a experiência do usuário.
      return {};
    });

  return cachedConfigPromise;
}

export default { getPublicApiConfig };
